import React from 'react';
import { useRouter } from 'next/router';
import { Modal, Button, Icon } from '@tencent/tea-component';
import LoadingIcon from '@assets/imgs/publishLoading.svg';
import PublishLoadingImg from '@assets/imgs/publish-loading.png';
import './index.scss';
interface PublishLoadingTypes {
  visible: boolean;
  onclose?: Function;
  type?: number;
}
const textArray = [
  { title: '活动发布中，请稍候……', msg: undefined, isShowLoadingIcon: true },
  {
    title: '活动已提交审核',
    msg: '平台将于2个自然日内完成审核，您可以在活动列表中查看活动发布状态',
    isShowLoadingIcon: false,
  },
];
const PublishLoading = (params: PublishLoadingTypes) => {
  const { visible, onclose } = params;
  const router = useRouter();
  const routerList = () => {
    onclose?.();
    router.push('/home');
  };
  // const textData = useMemo(() => textArray?.[type || 0], [type]);
  const textData = textArray[0];
  return (
    <Modal visible={visible} onClose={() => onclose?.()} className="publish-loading-modal">
      <Modal.Body>
        <div className="modal-title">
          <img src={LoadingIcon} className="modal-title-icon" />
          <span>{textData?.title}</span>
        </div>
        {!!textData?.msg && <div className="modal-desc">{textData?.msg}</div>}
        <img src={PublishLoadingImg} className="modal-content-img" />
        {textData?.isShowLoadingIcon && (
          <div className="modal-content-loading">
            <Icon type="loading" />
            活动正在发布...
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button type="weak" onClick={routerList}>
          返回活动列表
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default PublishLoading;
